import Swiper from "swiper/dist/js/swiper";

export default function() {

    const herlSwiperEl = document.querySelector('.hero__left .swiper-container');
    var options = {
        loop: true,
        slidesPerView: 1,
        simulateTouch: false,
        // effect: 'fade',
        speed: 600,
    };
    
    if(document.querySelectorAll('.hero__left .swiper-container .swiper-slide').length > 1) {
        options.autoplay = {
            delay: 7500,
            disableOnInteraction: false,
        };
    }
    
    let heroSwiper = new Swiper(herlSwiperEl, options);

}
